module.exports = __webpack_public_path__ + "static/media/Christian-Malmström.a0814892.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/Christian-Malmström.jpg
// module id = 97
// module chunks = 0